import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const AdminInquiries = ({ headers }) => {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    api.get("/admin/inquiries", { headers }).then((r) => setRows(r.data)).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="mt-6 grid gap-4 md:grid-cols-2" data-testid="admin-inquiries">
      {rows.map((r) => (
        <div key={r.id} className="border border-[#E5DACA] rounded-lg bg-white p-5" data-testid={`inquiry-${r.id}`}>
          <p className="font-mono text-[11px] uppercase tracking-widest text-[#A8832F]">{r.option || "Private evening"}</p>
          <p className="mt-2 font-display text-lg text-[#1F1B17]">{r.name}</p>
          <p className="text-sm text-[#6B6157]"><a href={`mailto:${r.email}`} className="hover:text-[#A8832F]">{r.email}</a>{r.phone && ` · ${r.phone}`}</p>
          {(r.club_name || r.city) && <p className="mt-2 text-sm font-semibold text-[#1F1B17]" data-testid={`inquiry-club-${r.id}`}>{[r.club_name, r.city].filter(Boolean).join(" · ")}</p>}
          <p className="mt-2 text-sm text-[#4A423A]">{r.guests ? `${r.guests} guests` : ""}{r.preferred_date && ` · ${r.preferred_date}`}</p>
          {r.message && <p className="mt-3 text-sm text-[#6B6157]">{r.message}</p>}
          <p className="mt-3 text-[11px] text-[#8A8076]">{new Date(r.created_at).toLocaleString()}</p>
        </div>
      ))}
      {!rows.length && <p className="text-[#6B6157]" data-testid="no-inquiries-message">No private requests yet.</p>}
    </div>
  );
};
